export default class httpClient {

}